<template>
  <div class="c-pie-style">
    <el-collapse>
      <el-collapse-item title="绘图区域">
        <style-sub-item title="配色设置">
          <el-form-item>
            <div class="c-pie-style-themes">
              <div class="c-pie-style-theme" v-for="(item, idx) in dataList" :key="idx">
                <el-color-picker @change="handleChange(item)"
                  v-model="item[customKey + 'seriesColor']"></el-color-picker>
                <span>{{ item[customKey + 'text'] }}</span>
              </div>
            </div>
          </el-form-item>
        </style-sub-item>
        <el-form-item>
          <div class="chart-form-item-warp" style="margin-top: 0">
            <span class="jz-chart-title-label">透明度</span>
            <el-slider style="flex:1"
              v-model="selectItem.styleConfig.commongConfig.columnBackgroundOpacity"></el-slider>
          </div>
        </el-form-item>
      </el-collapse-item>
      <legend-style :config="selectItem.styleConfig.commongConfig.legendConfig"></legend-style>
      <el-collapse-item title="数据标签">
        <el-form-item>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">是否开启</span>
            <el-switch v-model="selectItem.styleConfig.commongConfig.labelConfig.show">
            </el-switch>
          </div>
          <div class="chart-form-item-warp">
            <el-checkbox v-model="selectItem.styleConfig.commongConfig.labelConfig.showAll">全量显示</el-checkbox>
          </div>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">内容</span>
          </div>
          <el-checkbox-group v-model="selectItem.styleConfig.commongConfig.labelConfig.pieContent">
              <el-checkbox label="dim">维度</el-checkbox>
              <el-checkbox label="measure">度量</el-checkbox>
              <el-checkbox label="percent">占比</el-checkbox>
            </el-checkbox-group>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">位置</span>
            <el-select v-model="selectItem.styleConfig.commongConfig.labelConfig.position" placeholder="请选择"
              popper-class="c-select-style-popper">
              <el-option v-for="option in selectItem.type === 'Pie' ? pieLabelPositionOptions : labelPositionOptions"
                :key="option.value" :label="option.label" :value="option.value">
              </el-option>
            </el-select>
          </div>
          <text-style :config="selectItem.styleConfig.commongConfig.labelConfig.textConfig">
            <div class="chart-form-item-warp">
              <span class="jz-chart-title-label">
                占比小数位数
              </span>
              <el-select v-model="selectItem.styleConfig.commongConfig.labelConfig.textConfig.decimalPlaces"
                placeholder="请选择" popper-class="c-select-style-popper">
                <el-option v-for="option in decimalPlacesOptions" :key="option.value" :label="option.label"
                  :value="option.value">
                </el-option>
              </el-select>
            </div>
          </text-style>
        </el-form-item>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import styleSubItem from '../base/styleSubItem.vue'
import { transferObjectToArray, getFieldValueByCustomKey } from '../../utils/index'
import { customKey } from '../../utils/enum.data'
import textStyle from '../base/textStyle.vue'
import legendStyle from '../base/legendStyle.vue'
export default {    
  name: 'cColumnStyle',
  components: {
    styleSubItem,     
    textStyle,
    legendStyle
  },
  props: {
    selectItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      getFieldValueByCustomKey,
      customKey,
      // 标签位置选项
      labelPositionOptions: [
        { label: '自动', value: '' },
        { label: '顶部', value: 'top' },
        { label: '底部', value: 'bottom' },
        { label: '中间', value: 'middle' },
        { label: '左侧', value: 'left' },
        { label: '右侧', value: 'right' }
      ],
      pieLabelPositionOptions: [
        { label: '内部', value: 'inner' },
        { label: '外部', value: 'outer' },
        { label: '蜘蛛', value: 'spider' },
      ],
      // 小数位数选项
      decimalPlacesOptions: [
        { label: '0', value: 0 },
        { label: '1', value: 1 },
        { label: '2', value: 2 }
      ]
    }
  },
  computed: {
    dataList() {
      return transferObjectToArray(this.selectItem)
    }
  },
  methods: {
    handleChange(item) {
      this.$set(this.selectItem.styleConfig.helperData.fieldMap[item.key], customKey + 'seriesColor', item[customKey + 'seriesColor'])
    },
    formatTooltip(value) {
      return `${value}%`
    }
  }
}
</script>
<style scoped lang="less">
.c-pie-style {
  .c-pie-style-theme{
    &:not(:first-child){
      margin-top: 2px;
    }
    display: flex;
    align-items: center;
    margin-bottom: 2px;
    background: #fff;
    padding: 6px 12px;
    span{
      flex: 1;
      text-align: left;
      margin-left: 8px;
    }
    .el-color-picker{
      width: 26px;
    }
  }
  
  // 暗黑主题样式覆盖
  /deep/ .el-select-dropdown {
    background-color: #2c2f36 !important;
    border: 1px solid #404040 !important;
  }
  
  /deep/ .el-select-dropdown__item {
    background-color: #2c2f36 !important;
    color: #ffffff !important;
    
    &:hover {
      background-color: #404040 !important;
    }
    
    &.selected {
      background-color: #1890ff !important;
      color: #ffffff !important;
    }
  }
  
  /deep/ .el-select-dropdown__empty {
    color: #909399 !important;
  }
}

// 全局样式，用于覆盖 popper 渲染到 body 中的下拉框
</style>